import { Acl } from './acl';
import { CoordinatorService } from './coordinator.service';
import { ProjectMember } from './project-member';

export type ROLE = 'owner' | 'admin' | 'rater' | 'viewer';
export type ACL_SECTION =
    | 'project'
    | 'databin'
    | 'preview'
    | 'collection'
    | 'binary-tree'
    | 'view'
    | 'team'
    | 'stats'
    | 'report'
    | 'keyword'
    | 'book'
    | 'contents'
    | 'page';

export enum UserRole {
    Viewer = 1,
    Rater = 2,
    Admin = 3,
    Owner = 4,
}

export class Acl$ {
    // private _role: ROLE = "rater"

    private _aclMap = new Map<string, Acl>();

    inviteRoleLs: ROLE[] = [
        'rater',
        'viewer',
        // "admin"
    ];

    constructor(public coords: CoordinatorService) {
        (
            [
                'project',
                'databin',
                'collection',
                'binary-tree',
                'view',
                'team',
                'keyword',
            ] as ACL_SECTION[]
        ).forEach((section) => {
            const acl = new Acl(this.coords, section);
            this._aclMap.set(acl.id, acl);

            switch (section) {
                case 'project':
                    acl.set('display', UserRole.Viewer);
                    acl.set('invite', UserRole.Owner);
                    acl.set('edit', UserRole.Owner);
                    acl.set('export', UserRole.Owner);
                    acl.set('delete', UserRole.Owner);
                    acl.set('subsets', UserRole.Admin);
                    acl.set('keywords', UserRole.Admin);
                    acl.set('binary-tree', UserRole.Admin);
                    break;
                case 'binary-tree':
                    acl.set('create', UserRole.Owner);
                    acl.set('edit', UserRole.Rater);
                    break;
                case 'databin':
                    acl.set('display', UserRole.Admin);
                    break;
                case 'view':
                    acl.set('create', UserRole.Admin);
                    acl.set('edit', UserRole.Admin);
                    break;
                case 'keyword':
                    acl.set('create', UserRole.Admin);
                    break;
                case 'collection':
                    acl.set('edit', UserRole.Admin);
                    acl.set('bulk', UserRole.Rater);
                    break;
                case 'team':
                    acl.set('view-invitations', UserRole.Admin);
                    acl.set('view-members', UserRole.Admin);
                    break;
            }
        });
    }

    get currentProjectMember() {
        return this.coords.project$.current?.team?.currentUser;
    }

    isOn(section: ACL_SECTION, tag: string, role?: ROLE): boolean {
        const isVM = !!this.coords.project$.current?.isViewMode;
        if (!isVM && !this.coords.project$.current?.isCloud) return true;
        if (section === 'preview') section = 'databin';

        const acl = this._aclMap.get(section);
        if (!acl) return true;
        if (isVM) role = 'viewer';
        return acl.isOn(tag, role ? this._roleNumeric(role) : this.role);
    }

    private _roleNumeric(tag: ROLE) {
        switch (tag) {
            case 'owner':
                return UserRole.Owner;
            case 'admin':
                return UserRole.Admin;
            case 'rater':
                return UserRole.Rater;
            case 'viewer':
                return UserRole.Viewer;
        }
        return 0;
    }

    get role() {
        if (!this.coords.project$.current?.isCloud) return UserRole.Owner;
        if (!this.currentProjectMember) return UserRole.Viewer;
        return this._roleNumeric(this.currentProjectMember.role!);
    }

    get isOwner() {
        return this.role === UserRole.Owner;
    }
}
